/**
 * Render-less component providing no behavior.
 * Designed to be used as a behavior slot of tree component.
 */
export default {
  name: 'noBehavior',
  render: () => null
}



// WEBPACK FOOTER //
// ./src/behaviors/noBehavior.js